import React, { useContext, Suspense } from 'react';
import { RouteComponentProps, Switch } from 'react-router';

import { PostPreview } from '../post_preview/post_preview';
import { AddBlog } from '../add_blog/add_blog';
import { AddQuestion } from '../add_question/add_question';
import { Unsubscribe } from '../unsubscribe/unsubscribe';
import { ApplicationContext } from '../../utils';
import { PageReload } from '../../components/PageReload';
import { Route } from '../../components/Route';

export interface IRoutesParams {
  onRender?(routeProps: RouteComponentProps): void;
}

export const Routes = (props: IRoutesParams) => {
  const {
    custom: {
      isNewDesignForPostPreviewCardEnabled,
      isNewDesignForAddQuestionPageEnabled,
      isNewDesignForAddBlogPageEnabled,
      isNewDesignForUnsubscribeEmailPageEnabled,
    },
  } = useContext(ApplicationContext);

  return (
    <Suspense fallback={null}>
      <Switch>
        <Route path={`/(content-)?preview`} component={PostPreview} {...props}>
          {isNewDesignForPostPreviewCardEnabled && <PageReload />}
        </Route>

        <Route path={`/add-blog/`} component={AddBlog} {...props}>
          {isNewDesignForAddBlogPageEnabled && <PageReload />}
        </Route>

        <Route path={`/add-vopros/`} component={AddQuestion} {...props}>
          {isNewDesignForAddQuestionPageEnabled && <PageReload />}
        </Route>

        <Route path={`/unsubscribe-email/`} component={Unsubscribe} {...props}>
          {isNewDesignForUnsubscribeEmailPageEnabled && <PageReload />}
        </Route>

        <Route>
          <PageReload />
        </Route>
      </Switch>
    </Suspense>
  );
};
